import { render, staticRenderFns } from "./GraphDetail28.vue?vue&type=template&id=cf13281e&scoped=true"
import script from "./GraphDetail28.vue?vue&type=script&lang=js"
export * from "./GraphDetail28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf13281e",
  null
  
)

export default component.exports